<template>
  <b-row>
    <b-col>
      <b-form-group
        label="Kapının En Ölçüsü"
        label-for="x_door"
      >

        <b-input-group append="cm">
          <cleave
            id="x_door"
            v-model="dataItem.x_door"
            class="form-control"
            :raw="true"
            :options="options"
            placeholder="Giriniz"
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group
        label="Kapının Boy Ölçüsü"
        label-for="y_door"
      >
        <b-input-group append="cm">
          <cleave
            id="y_door"
            v-model="dataItem.y_door"
            class="form-control"
            :raw="true"
            :options="options"
            placeholder="Giriniz"
          />
        </b-input-group>

      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group
        label="Kapının Yükseklik Ölçüsü"
        label-for="z_door"
      >
        <b-input-group append="cm">
          <cleave
            id="z_door"
            v-model="dataItem.z_door"
            class="form-control"
            :raw="true"
            :options="options"
            placeholder="Giriniz"
          />
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>

</template>
<script>
import {
  BFormGroup, BInputGroup, BRow, BCol,
} from 'bootstrap-vue'
import { required } from '@core/utils/validations/validations'
import Cleave from 'vue-cleave-component'
import { localize } from 'vee-validate'

export default {
  name: 'ProjectDoorAreaCard',
  components: {
    BFormGroup,
    BInputGroup,
    Cleave,
    BRow,
    BCol,
  },
  data() {
    return {
      required,
      options: {
        numeral: true,
        numeralDecimalMark: ',',
        delimiter: '.',
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
